module.exports = __webpack_public_path__ + "upc.png?5a212c888dff9b5c803636bfa276f466";


//////////////////
// WEBPACK FOOTER
// ./src/assets/upc.png
// module id = 374
// module chunks = 0